import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { AuthService } from 'src/app/services/auth.service';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-create-chat',
  templateUrl: './create-chat.component.html',
  styleUrls: ['./create-chat.component.scss']
})
export class CreateChatComponent implements OnInit {

  constructor(protected ref: NbDialogRef<CreateChatComponent>, 
    private authService: AuthService,
    private profile: ProfileService) { }
  text: string = '';
  selectedUsersIds: any[];
  all_users = [];
  show: boolean = false;
  friends = [];

  ngOnInit (): void {
    const userId = this.authService.getLocalStorage('user').id;

    this.profile.get_all_friends()
    .subscribe({
      next: (data) => {
        if(data){
        this.friends = data.filter(el => el.userId != userId);
        this.friends.sort((a,b) => (b.firstName > a.firstName) ? -1 : ((a.firstName > b.firstName) ? 1 : 0));
        // console.log(this.friends);
        if(this.friends.length > 0)  this.selectedUsersIds = [''];
          else this.selectedUsersIds = [];
          setTimeout(() => {
            this.show = true;
          }, 100);
          // console.log(this.all_users)
      
        }
      }});

    // this.authService.get_all_users().subscribe(res => {
    //   if(res.length > 0) {
    //     this.all_users = res.filter(el => el.userId != userId);
    //     this.all_users.sort((a,b) => (b.firstName > a.firstName) ? -1 : ((a.firstName > b.firstName) ? 1 : 0));
    //       // if(this.all_users.length > 0)  this.selectedUsersIds = [this.all_users[0].userId];
    //       if(this.all_users.length > 0)  this.selectedUsersIds = [''];
    //       else this.selectedUsersIds = [];
    //       setTimeout(() => {
    //         this.show = true;
    //       }, 100);
    //       // console.log(this.all_users)
    //   }
    // });
  }

  close () {
    this.ref.close();
  }

  save() {
    if(this.selectedUsersIds.length > 0) {
      const data = {
        userIds: [...Array.from(this.selectedUsersIds, id => id.toString())],
        name: this.text,
        type: "consumer-to-consumer"
      }
      // console.log(data)
      this.ref.close(data);
    }
  }

}
